import React from 'react'

const PlusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 17 16" fill="none">
            <path d="M8.69885 3.4212V12.5789M4.12 8.00006H13.2777" stroke="currentColor" strokeWidth="1.30824" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default PlusIcon
